var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import menuReturn from '../../components/console-common/menu-return.vue';
import online from './violation-purchase-online.vue';
import qrcode from './violation-purchase-qrcode.vue';
import offline from './violation-purchase-offline.vue';
import { toYuan } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'purchaseModel',
    components: {
        'el-menu-return': menuReturn,
        'el-qrcode': qrcode,
        'el-online': online,
        'el-offline': offline,
    },
    computed: __assign({}, mapState('balance', {
        balanceData: 'balanceData',
    })),
    data: function () {
        return {
            active: 'online',
            titleConfig: {
                backTitle: '返回违章查询',
                currentTitle: '购买查询次数',
                routerName: true,
                name: 'violationQuery',
            },
            draw: '',
        };
    },
    created: function () {
        this.$store.dispatch('balance/GET_BALANCE');
    },
    methods: {
        changeYuan: function (val) {
            return toYuan(val);
        },
        purchaseRecord: function () {
            this.$router.push({
                name: 'violationPurchaseRecord',
            });
        },
    },
    watch: {
        balanceData: function (val) {
            if (!val) {
                return;
            }
            var draw = val.draw;
            this.draw = draw ? toYuan(draw) : '';
        },
    },
});
